<template>
  <div>
    <div class="card-title">
      <div class="l">按钮权限</div>
      <div class="r" style="font-size: 14px;" v-if="list.length > 1">
        <el-checkbox
          v-model="allChecked"
          @change="toggleAll"
          :indeterminate="isIndeterminate"
        >全选</el-checkbox>
      </div>
    </div>
    <el-form v-loading="loading">
      <template v-if="list.length">
        <div v-for="item in list" :key="item.buttonId" class="wrap-check">
          <el-checkbox
            v-model="item.checked"
            @change="handleChange(arguments[0], item)"
          >{{item.description}}({{item.widgetId.split('-')[1]}})</el-checkbox>
        </div>
      </template>
      <div v-else class="form-list--empty-block">暂无数据</div>
    </el-form>
  </div>
</template>

<script>
import {system} from '../../api'

export default {
  name: 'AuthButtonList',
  props: {
    currentMenuCode: String,
    currentRole: String,
    changeRecords: Object
  },
  mounted () {
    if (this.currentRole && this.currentMenuCode) this.getButtonList()
  },
  watch: {
    currentMenuCode (newValue, oldValue) {
      if (newValue !== oldValue) this.getButtonList()
    },
    currentRole (newValue, oldValue) {
      if (newValue !== oldValue) this.getButtonList()
    }
  },
  data () {
    return {
      loading: false,
      list: [],
      allChecked: false,
      isIndeterminate: true
    }
  },
  methods: {
    toggleAll (value) {
      for (let item of this.list) {
        item.checked = value
        this.handleChange(value, item)
      }
      this.isIndeterminate = false
    },
    async getButtonList () {
      this.list = []
      if (!(this.currentMenuCode && this.currentRole)) return
      this.loading = true
      let {data} = await system.getMenuButtonList(this.$store.state.user.roleId, this.currentRole, this.currentMenuCode)
      this.loading = false
      this.list = data
      this.updateCheckAll()
    },
    handleChange (value, item) {
      if (value) {
        let index = this.changeRecords.unchecked.findIndex(x => x === item.buttonId)
        if (index === -1) {
          this.$emit('add-record', 'checked', item.buttonId)
        } else {
          this.$emit('remove-record', 'unchecked', index)
        }
      } else {
        let index = this.changeRecords.checked.findIndex(x => x === item.buttonId)
        if (index === -1) {
          this.$emit('add-record', 'unchecked', item.buttonId)
        } else {
          this.$emit('remove-record', 'checked', index)
        }
      }
      this.updateCheckAll()
    },
    updateCheckAll () {
      let size = this.list.reduce((total, item) => item.checked ? total + 1 : total, 0)
      this.allChecked = size !== 0 && size === this.list.length
      this.isIndeterminate = size !== 0 && size !== this.list.length
    }
  }
}
</script>

<style scoped lang="scss">
.form-list--empty-block {
  @extend %no-data-normal;
  text-align: center;
  height: 60px;
  line-height: 60px;
}
.wrap-check {
  height: 48px;
  color: #666;
  border-top: 1px solid #eee;
  display: flex;
  align-items: center;
}
</style>
